import { render, staticRenderFns } from "./DashboardCurrenciesCard.html?vue&type=template&id=662d74fa&scoped=true&"
import script from "./DashboardCurrenciesCard.js?vue&type=script&lang=js&"
export * from "./DashboardCurrenciesCard.js?vue&type=script&lang=js&"
import style0 from "./DashboardCurrenciesCard.scss?vue&type=style&index=0&id=662d74fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662d74fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VImg,VRow,VSkeletonLoader})
